export default "__VITE_ASSET__7Cmrdh4Y__"